import { createSelector } from '@reduxjs/toolkit';
import { eventOccurrencesNotDeleted } from './event-occurrences-not-deleted';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import type { EventOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { groupBy, sortBy } from 'lodash';
import { toEventModel } from './to-event-model';

export const events = createSelector(eventOccurrencesNotDeleted, currentEmployeeUuid, function (occurrences) {
  const unnamedEvents: { name: string; eventOccurrences: EventOccurrenceViewModel[] }[] = occurrences
    .filter((o) => o.name === '')
    .map((o) => {
      return {
        name: '',
        eventOccurrences: [o],
      };
    });
  const namedOccurrences = occurrences.filter((o) => o.name !== '');
  const groupedOccurrences = groupBy(namedOccurrences, (e) => e.name);
  const namedEvents: { name: string; eventOccurrences: EventOccurrenceViewModel[] }[] = Object.entries(
    groupedOccurrences,
  ).map((group) => toEventModel(group[1]));
  const allEvents = unnamedEvents.concat(namedEvents);
  return sortBy(allEvents, [(e) => e.name.toLowerCase()]);
});
